export default __webpack_public_path__ + "static/media/PPI-garden-bed-008.2cf25e99.jpg";